import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import EmergencyContactFields from "./EmergencyContactFields";

const EmergencyContact = ({
    allowableEmergencyContacts = 0,
    emergencyContactCell = 0,
    emergencyContactEmail = 0,
    options,
    subsectionHeading,
    additionalText = "",
    isVisible,
    Country,
}) => {
    const emergencyContactSettings = {
        emergencyContactCell,
        emergencyContactEmail,
        Country,
        ...options,
    };

    return (
        <>
            {isVisible && allowableEmergencyContacts > 0 && (
                <div className="grid">
                    <div className="col col--12">
                        <h3 className="-type--regular -margin-bottom--5">
                            <Icon
                                className="-type--xlarge -margin-right--5"
                                glyph="address-book-solid"
                                type="FontAwesome"
                            />{" "}
                            <span>{subsectionHeading}</span>
                        </h3>
                        {additionalText && <small>{additionalText}</small>}
                    </div>
                    <EmergencyContactFields {...emergencyContactSettings} />
                </div>
            )}
            {/* only show if 2 is selected */}
            {isVisible && allowableEmergencyContacts > 1 && (
                // eslint-disable-next-line tailwindcss/classnames-order
                <div className="grid -margin-top--15">
                    <div className="col col--12">
                        <h3 className="-type--regular -margin-bottom--5">
                            <Icon
                                className="-type--xlarge -margin-right--5"
                                glyph="address-book-solid"
                                type="FontAwesome"
                            />{" "}
                            <span>{subsectionHeading}</span>
                        </h3>
                        {additionalText && <small>{additionalText}</small>}
                    </div>
                    <EmergencyContactFields
                        {...emergencyContactSettings}
                        suffix="2"
                    />
                </div>
            )}
        </>
    );
};

EmergencyContact.propTypes = {
    // Flag determining whether this component is visible
    allowableEmergencyContacts: PropTypes.number,
    isVisible: PropTypes.bool.isRequired,
    emergencyContactCell: PropTypes.number,
    emergencyContactEmail: PropTypes.number,
    subsectionHeading: PropTypes.string.isRequired,
    additionalText: PropTypes.string,
    options: PropTypes.shape({}).isRequired,
    Country: PropTypes.string.isRequired,
};

export default EmergencyContact;
